/* eslint-disable */
import React from 'react'
import styled from 'styled-components'
import { Checkbox as AntdCheckbox } from 'antd'

const StyledCheckbox = styled(AntdCheckbox)`
  .ant-checkbox + span {
    padding-left: 12px;
  }
  .ant-checkbox-inner {
    height: 18px; 
    width: 18px;
    border-radius: 5px;
    border: 2px solid #CCCFD6; /* Black border for enabled (not checked) checkboxes */
  }

  .ant-checkbox-input:checked + .ant-checkbox-inner {
    border:none;
  }
  
  .ant-checkbox-input:checked + .ant-checkbox-inner {
    border:none;
  }
  
  border-width: 2px;
  .ant-checkbox-wrapper {
    padding: 5px !important;
  }
`
const LabelWrapper = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: #000000;
  cursor:pointer;
  margin-bottom:8px;
`
const CheckboxSelectAll = ({ onChange, label, value, name, rules, ...rest }) => {
  return (
    <StyledCheckbox {...rest} onChange={onChange} checked={value}>
      <LabelWrapper>{label}</LabelWrapper>
    </StyledCheckbox>
  )
}
export default CheckboxSelectAll
